import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsDiscardedmanager} from "../../ui-components";
import LeadsContext from '../../context/leads';


function DiscardedLeader({onToggleTab,setAssignLead, order}) {
  const {LeadsAsign, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    LeadsAsign(2, 4, order);
    Subs();
  },[order])

  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="discardedmanager"/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsDiscardedmanager key={lead.id} leads={lead} overrides={{
        Button:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        }}}/> :
      <RowLeadsDiscardedmanager key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"},
        Button:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        }
      }}/> 
    ))}
  </div>

  )
}

export default DiscardedLeader